// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DribbbleOutlinedSvg from "@ant-design/icons-svg/es/asn/DribbbleOutlined";
import AntdIcon from '../components/AntdIcon';

var DribbbleOutlined = function DribbbleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleOutlinedSvg
  }));
};

DribbbleOutlined.displayName = 'DribbbleOutlined';
export default React.forwardRef(DribbbleOutlined);